import React from "react";
import { Button } from "primereact/button";
import { ScrollPanel } from "primereact/scrollpanel";

interface IProps {
  componente: React.ReactElement;
  onCancelar: Function;
  onAcceptar: Function;
}

export const AceptarTerminos = (props: IProps) => {
  const onCancelar = (e: any) => {
    e.preventDefault();
    props.onCancelar();
  };
  const onAcceptar = (e: any) => {
    e.preventDefault();
    props.onAcceptar();
  };
  return (
    <ScrollPanel style={{ width: "100%", height: "500px" }}>
      <div style={{ padding: "1em", lineHeight: "1.5" }}>
        <div className="d-flex justify-content-end mt-3 mb-3">
          <Button
            label="Cancelar"
            icon="pi pi-times"
            onClick={onCancelar}
            className="p-button-secondary mr-2"
          />
          <Button
            className="ml-2"
            label="Aceptar"
            icon="pi pi-check"
            onClick={onAcceptar}
          />
        </div>
        {props.componente}
      </div>
    </ScrollPanel>
  );
};
